import React from "react";
import { Box } from "@mui/material";
import IncomeListTab from "./IncomeListTab";

/**
 * 収入サブタブ (収支 > 収入)
 *
 * 物件全体の入金 (PaymentRecord) を一覧表示する物件全体ビュー。
 * 契約軸で見る既存の PaymentHistoryTab (Unit 詳細配下) とは併存する (§5.2)。
 */

interface IncomeSummarySubTabProps {
  propertyId: string;
  propertyName?: string;
}

const IncomeSummarySubTab: React.FC<IncomeSummarySubTabProps> = ({
  propertyId,
  propertyName,
}) => {
  return (
    <Box>
      <IncomeListTab propertyId={propertyId} propertyName={propertyName} />
    </Box>
  );
};

export default IncomeSummarySubTab;
